import { gql } from '@apollo/client';

/**
 * The tag manager (plan 4.2). Every tag comes in one request: the API has no
 * paging for tags, and the CRM holds hundreds, not thousands. `lastAddedAt`
 * costs one index probe per tag and is asked only here.
 *
 * Backend: ilbp-backend docs/CRM_TAG_AND_LIST_MANAGER.md. Admin-only.
 */

const TAG_FIELDS = `
  id
  name
  category
  color
  description
  isSystem
  contactCount
  createdAt
  updatedAt
  lastAddedAt
`;

export const CRM_TAG_MANAGER = gql`
  query CrmTagManager {
    crmTags {
      ${TAG_FIELDS}
    }
  }
`;

export const CRM_MANAGER_CREATE_TAG = gql`
  mutation CrmManagerCreateTag($name: String!, $category: String, $color: String, $description: String) {
    crmCreateTag(name: $name, category: $category, color: $color, description: $description) {
      ${TAG_FIELDS}
    }
  }
`;

/** Only the fields sent change; "" clears category, colour or description. */
export const CRM_UPDATE_TAG = gql`
  mutation CrmUpdateTag($id: Int!, $name: String, $category: String, $color: String, $description: String) {
    crmUpdateTag(id: $id, name: $name, category: $category, color: $color, description: $description) {
      ${TAG_FIELDS}
    }
  }
`;

/** `expectedCount` is the count the admin confirmed; on any other the API deletes nothing. */
export const CRM_DELETE_TAG = gql`
  mutation CrmDeleteTag($id: Int!, $expectedCount: Int!) {
    crmDeleteTag(id: $id, expectedCount: $expectedCount)
  }
`;
